import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchCustomerData_api = async (keyword: string | null = null, page = 1, limit = 10) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Customers/fetch_customer_list.php`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          keyword: keyword || null,
          page,
          limit
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Fetch customer data failed:", error);
    return { error: "Fetch customer data failed" };
  }
};
